import React from 'react';

import InputPrimary from '../common/InputPrimary';
import i18n from '../core/i18n';

export const maxLength = (max) => (value) =>
  value && value.split(' ').length > max
    ? `Must be ${max} words or less`
    : undefined;

export const maxCharLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} words or less` : undefined;

export const required = (value) =>
  value || typeof value === 'number' ? undefined : 'Required';

// https://stackoverflow.com/a/5717133/1333836
const urlPattern = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
  'i'
); // fragment locator

export const isValidURL = (str) => {
  // Trick to allow empty values (make field not required)
  if (!str) {
    return undefined;
  }

  return urlPattern.test(str) ? undefined : 'Invalid';
};

export const areValidURLs = (str = '') => {
  // Trick to allow empty values (make field not required)
  if (!str) {
    return undefined;
  }

  return str
    .split(',')
    .map((link) => link.trim())
    .filter((link) => link.length)
    .map((link) => urlPattern.test(link))
    .every((link) => link)
    ? undefined
    : 'Invalid';
};

export const TextArea = (field) => {
  const value = field.input.value;
  const valueCount =
    field.maxBy === 'CHAR' ? value.length : value.split(' ').length;
  const suffix =
    field.maxBy === 'CHAR' ? i18n.t('general.chars') : i18n.t('general.words');

  return (
    <div className="u-position-relative">
      <InputPrimary
        rows={4}
        elType="TEXTAREA"
        className="c-input u-margin-bottom-tiny"
        value={value}
        onChange={(e) => field.input.onChange(e.target.value)}
        name={field.input.name}
        {...field}
      />
      {field.max && (
        <div className="c-input__counter">
          <span
            className={`c-input__counter${
              !value
                ? '--basic'
                : valueCount > field.max
                  ? '--invalid'
                  : '--valid'
            }`}
          >
            {value ? valueCount : 0}{' '}
          </span>
          / {field.max} {suffix}
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/utils/form.js